<app-base-doughnut-chart
[chartId]="chartId"
[title]="title"
[labels]="labels"
[data]="data"
[colors]="colors"
[fontColor]="fontColor"
legendPosition="left"
>
</app-base-doughnut-chart>
<!-- legendPosition="left" -->